import { defineStore } from 'pinia';
import { useCacheImage } from '@/shared/composables/useCacheImage';

export const useAssetsStore = defineStore('assets', {
	state: () => {
		return {
			logoUrl: '',
			backgroundUrl: '',
		};
	},
	actions: {
		async updateAssetsValues(assetsValues: { logoUrl: string; backgroundUrl: string }) {
			const { setImageToCache } = useCacheImage();
			console.log('Updating pinia', assetsValues);
			this.logoUrl = assetsValues.logoUrl;
			this.backgroundUrl = assetsValues.backgroundUrl;

			// Saving images on cache
			let logoImage = assetsValues.logoUrl.split('/').pop();
			logoImage = logoImage ?? 'logo';
			await setImageToCache('logo', logoImage, assetsValues.logoUrl);

			let backgroundImage = assetsValues.backgroundUrl.split('/').pop();
			backgroundImage = backgroundImage ?? 'bg';
			await setImageToCache('background', backgroundImage, assetsValues.backgroundUrl);
		},
	},
});
